let setCentre = function ({ commit }, centre) {
  return commit('setCentre', { centre })
}
let setZoom = function ({ commit }, zoom) {
    return commit('setZoom', { zoom })
}

export const actions = {
  setCentre,
  setZoom,
}
